/* eslint-disable */

import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "material-ui/styles";
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel
} from "material-ui/Table";
import green from "material-ui/colors/green";
import { CircularProgress } from "material-ui/Progress";
import Toolbar from "material-ui/Toolbar";
import Typography from "material-ui/Typography";
import Paper from "material-ui/Paper";
import Tooltip from "material-ui/Tooltip";
import Button from "material-ui/Button";
import AddIcon from "material-ui-icons/Add";
import { withRouter } from "react-router";
import { lighten } from "material-ui/styles/colorManipulator";
import { translate } from "react-i18next";

import { assets } from "../assets/";
import { enums } from "../enums/"

import {
  getAssetsProducingStart,
  sortAssetsProducing,
  changePage,
  changeRowsPerPage
} from "../actions";

import { checkUserIsAdmin } from '../utils/user/checkAdmin/CheckAdmin';

let counter = 0;

function createData(name, id, fat, carbs, protein) {
  counter += 1;
  return { id: counter, name, id, fat, carbs, protein };
}

const columnData = [
  { id: "street", numeric: false, disablePadding: false, label: "Site" },
  { id: "organization", numeric: false, disablePadding: false, label: "Organization" }
];

class AssetsProducingHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {
      order,
      orderBy,
      t
    } = this.props;

    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? "none" : "default"}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title={t("Sort")}
                  placement={column.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {t(column.label)}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

AssetsProducingHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85)
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark
        },
  spacer: {
    flex: "1 1 100%"
  },
  actions: {
    color: theme.palette.text.secondary
  },
  title: {
    flex: "0 0 auto"
  }
});

let AssetsProducingToolbar = props => {
  const { numSelected, classes, loading, t } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="title">
            {t("Producing assets")}
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </Typography>
        )}
      </div>
    </Toolbar>
  );
};

AssetsProducingToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired
};

AssetsProducingToolbar = withStyles(toolbarStyles)(AssetsProducingToolbar);

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
  },
  buttonProgress: {
    color: green[500],
    position: "relative",
    bottom: -30,
    left: 100,
    marginTop: -12,
    marginLeft: -12
  }
});

class AssetsProducing extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      order: "asc",
      orderBy: "id",
      selected: [],
      data: [
        createData("Frasnes", 0, 3.7, 67, 4.3),
        createData("Fontanelles", 1, 25.0, 51, 4.9),
        createData("Eget", 2, 16.0, 24, 6.0),
        createData("Burgum", 3, 6.0, 24, 4.0),
        createData("Marèges", 4, 16.0, 49, 3.9)
      ].sort((a, b) => (a.id < b.id ? -1 : 1)),
      page: 0,
      rowsPerPage: 5
    };
  }
  componentDidMount = () => {
    if (this.props.isAuthenticated) {
      this.props.getAssetsProducingStart();
    } else {
      this.props.history.push("/");
    }
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.props.orderBy === property && this.props.order === "desc") {
      order = "asc";
    }

    const assets =
      order === "desc"
        ? this.props.assets.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
        : this.props.assets.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

    this.props.sortAssetsProducing(assets, order, orderBy);
  };

  handleChangePage = (event, page) => {
    this.props.changePage(page);
  };

  handleClick = (event, id) => {
    this.props.history.push("/assets/prod/read/" + id);
  };

  //Below are functions provided initially by material ui
  //Visit https://material-ui-next.com/demos/tables/#sorting-amp-selecting for details

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState({ selected: this.state.data.map(n => n.id) }); //Do this redux way
      return;
    }
    this.setState({ selected: [] }); //Do this redux way
  };

  handleClickSelect = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangeRowsPerPage = event => {
    this.props.changeRowsPerPage(event.target.value);
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  renderCreateButton() {
    const { classes, user, isAuthenticated } = this.props;
    if (checkUserIsAdmin(isAuthenticated, user)) {
      return (
        <Button
          variant="fab"
          color="primary"
          aria-label="add"
          className={classes.button}
          style={{
            margin: 0,
            bottom: "auto",
            right: 48,
            top: 85,
            left: "auto",
            position: "fixed"
          }}
          onClick={() => {
            this.props.history.push("/assets/prod/create");
          }}
        >
          <AddIcon />
        </Button>
      );
    } else return false;
  }

  render() {
    const { classes } = this.props;

    const {
      assetsProducing,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      loading,
      t,
      i18n,
      isAuthenticated,
      user
    } = this.props;
    const emptyRows =
      rowsPerPage -
      Math.min(rowsPerPage, assetsProducing.length - page * rowsPerPage);

    return (
      <div className={classes.root}>
        <Paper className={classes.root}>
          <AssetsProducingToolbar
            numSelected={selected.length}
            loading={loading}
            t={t}
            i18n={i18n}
          />
          <div>
            <Table className={classes.table} style={{ minWidth: 0 }}>
              <AssetsProducingHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={this.handleRequestSort}
                rowCount={assetsProducing.length}
                t={t}
                i18n={i18n}
              />
              <TableBody>
                {assetsProducing
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map(n => {
                    const isSelected = this.isSelected(n.id);

                    let assetIcon;
                    
                    switch (n.assetType) {
                      case enums.AssetType.WIND_TURBINE:
                        assetIcon = assets.images.windTurbineMapIcon2;
                        break;
                      case enums.AssetType.SOLAR_PANEL:
                        assetIcon = assets.images.solarPanelMapIcon2;
                        break;
                      case enums.AssetType.DAM:
                        assetIcon = assets.images.damMapIcon2;
                        break;
                      case enums.AssetType.FACTORY:
                        assetIcon = assets.images.factoryMapIcon2;
                        break;
                      case enums.AssetType.GEOTHERMAL:
                        assetIcon = assets.images.geothermalIcon;
                        break;
                      case enums.AssetType.SOLID_BIOMASS:
                        assetIcon = assets.images.solidBiomassIcon;
                        break;
                      default:
                        assetIcon = assets.icons.boltMapIcon2;
                    }

                    if (!n.active)
                      return (
                        <TableRow
                          hover
                          onClick={event => this.handleClick(event, n.id)}
                          role="checkbox"
                          aria-checked={isSelected}
                          tabIndex={-1}
                          key={n.id}
                          selected={isSelected}
                        >
                          <TableCell
                            style={{
                              cursor: "pointer"
                            }}
                          >
                            <img src={assetIcon} style={{ maxHeight: 16, marginRight: 10 }} />
                            {n.displayedName
                              ? n.displayedName
                              : "Unknown asset"}
                          </TableCell>
                          <TableCell
                            style={{
                              cursor: "pointer"
                            }}
                          >
                            {checkUserIsAdmin(isAuthenticated, user) && n.organizations && n.organizations.length > 0 && n.organizations.map(o => {
                              return ( <p>{o.organization.name} {o.percentage*100}%</p>)
                            })}

                            {!checkUserIsAdmin(isAuthenticated, user) && n.organizations && n.organizations.length > 0 && n.organizations.map(o => {
                              return ( <p>{o.organization.name}</p>)
                            })}

                            {(!n.organizations || n.organizations.length < 1) && ("No organization")}
                          </TableCell>
                        </TableRow>
                      );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            component="div"
            count={assetsProducing.length}
            labelDisplayedRows={({ from, to, count }) =>
              from + "-" + to + t(" of ") + count
            }
            labelRowsPerPage={t("RowsPerPage")}
            rowsPerPageOptions={[5, 10, 25, 100]}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page"
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page"
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        {this.renderCreateButton()}
      </div>
    );
  }
}

AssetsProducing.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = ({
  assetsProducingReducer,
  router,
  loginReducer
}) => {
  const {
    currentAssetProducing,
    assetsProducing,
    loading,
    order,
    orderBy,
    selected,
    page,
    rowsPerPage
  } = assetsProducingReducer;
  const { location } = router;
  const { isAuthenticated, username, user } = loginReducer;

  let archivedAssetsProducing = assetsProducing.filter(assetProducing => !assetProducing.active)

  return {
    currentAssetProducing,
    assetsProducing: archivedAssetsProducing,
    loading,
    order,
    orderBy,
    selected,
    page,
    rowsPerPage,
    location,
    isAuthenticated,
    username,
    user
  };
};

const mapDispatchToProps = {
  getAssetsProducingStart,
  sortAssetsProducing,
  changePage,
  changeRowsPerPage
};

AssetsProducing = withStyles(styles, { name: "AssetsProducing" })(
  AssetsProducing
);
AssetsProducing = translate("translations")(AssetsProducing);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AssetsProducing)
);



// WEBPACK FOOTER //
// ./src/components/AssetsProducingArchived.js